export const initListData = [];
export const initToastData = {

	toastType: 'Hint',
	showState: false

};